import React from "react";
import gpay from "../../../../assets/DigitalMarketing/image/cards.png";
import cash from "../../../../assets/DigitalMarketing/image/cash.svg";
import online from "../../../../assets/DigitalMarketing/image/wallet.png";

const PaymentMode = (data: any) => {

  const paymentData = [
    { id: 1, mode: "Online", amount: data?.data?.onlineAmount, img: cash },
    { id: 2, mode: "Cash", amount: data?.data?.cashAmount, img: online},
    { id: 3, mode: "Card", amount: data?.data?.cardAmount, img: gpay },
  ];
  return (
    <div>
      <div>
        <span className="dashboard-heading mb-4">Payment Modes</span>
      </div>
      {paymentData.map((payment) => (
        <div
          key={payment.id}
          className="card border mt-2 p-2 d-flex flex-row justify-content-between align-items-center"
        >
          <div className="d-flex align-items-center">
            <img
              src={payment.img}
              alt={payment.mode}
              className="rounded-circle me-3"
              style={{ width: "40px", height: "40px" }}
            />
            <span className="f-18 fw-400">{payment.mode}</span>
          </div>
          <div>
            <span className="fw-700 f-16 " style={{ color: "#6842D9" }}>
              ₹{payment.amount}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PaymentMode;
